module.exports = __webpack_public_path__ + "static/media/SourceSansPro-LightItalic.e9995306.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/SourceSansPro-LightItalic.woff2
// module id = 3437
// module chunks = 51